import { useEffect } from "react";
import { Modal as MuiModal } from "@mui/material";
import { useActionChoices } from "stores";
import { useActionModalGetContext } from "context/ActionModalProvider";
import { FETCH_STATE } from "constants/fetchState";
import { useAgronomistDashboardActionAlertsMutation } from "pages/AgronomistDashboard/_hooks/useAgronomistDashboardFieldsQuery";
import Loader from "../Loader/Loader";
import NoContentFound from "../NoContentFound/NoContentFound";
import CommonActionReadyContent, {
  CommonActionModalWrapper,
} from "./content/CommonActionReadyContent";

const CommonActionModal = ({
  isOpen,
  onClose,
  selectedFields,
  onActionSaved = () => {},
}) => {
  const { fetchState, errorMessage } = useActionModalGetContext();
  const { fetchState: actionsFetchState } = useActionChoices();
  const {
    actionAlerts,
    fetchActionAlerts,
    isError: isActionAlertsError,
    isPending: isActionAlertsLoading,
    reset: resetActionAlerts,
  } = useAgronomistDashboardActionAlertsMutation();
  const firstSelectedField = selectedFields?.[0];
  const firstSelectedFieldId = firstSelectedField?.id;
  const firstSelectedCropId = firstSelectedField?.cropId;

  useEffect(() => {
    if (!isOpen || !firstSelectedFieldId || !firstSelectedCropId) {
      resetActionAlerts();
      return;
    }
    fetchActionAlerts({
      fieldId: firstSelectedFieldId,
      cropId: firstSelectedCropId,
      date: new Date(),
    });
  }, [
    fetchActionAlerts,
    firstSelectedCropId,
    firstSelectedFieldId,
    isOpen,
    resetActionAlerts,
  ]);

  const isReady =
    fetchState === FETCH_STATE.SUCCESS && actionsFetchState.isSuccess;
  const isLoading =
    fetchState === FETCH_STATE.LOADING || actionsFetchState.isLoading;

  return (
    <MuiModal open={isOpen} onClose={onClose}>
      <CommonActionModalWrapper>
        {isLoading && <Loader size={50} />}
        {fetchState === FETCH_STATE.ERROR && (
          <NoContentFound text={errorMessage} />
        )}
        {isReady && (
          <CommonActionReadyContent
            actionAlerts={actionAlerts}
            isActionAlertsError={isActionAlertsError}
            isActionAlertsLoading={isActionAlertsLoading}
            selectedFields={selectedFields}
            onActionSaved={onActionSaved}
            onClose={onClose}
          />
        )}
      </CommonActionModalWrapper>
    </MuiModal>
  );
};

export default CommonActionModal;
